import { render, staticRenderFns } from "./largeButton.vue?vue&type=template&id=2a8c36ec"
import script from "./largeButton.vue?vue&type=script&lang=js"
export * from "./largeButton.vue?vue&type=script&lang=js"
import style0 from "./largeButton.vue?vue&type=style&index=0&id=2a8c36ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports